module.exports = __webpack_public_path__ + "static/media/img_return_visit.23778292.svg";